import { createMuiTheme, createTheme, PaletteColorOptions, SxProps, Theme } from "@mui/material/styles";
import AsyncNavButton from "./asyncNavButton";
import AsyncString from "./asyncString";
import { useSignedInState } from "../hooks/useAuthState";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface AuthButtonProps {
    fullWidth?: boolean;
    sx?: SxProps<Theme>;
}

export function AuthButton(props: AuthButtonProps) {
    const navigate = useNavigate();
    const signedIn = useSignedInState();

    const sendFlutterMessage = (message: string, data?: any) => {
        if ((window as any).isFlutterWebView && (window as any).FlutterBridge) {
            (window as any).FlutterBridge.postMessage(
                JSON.stringify({ message, data })
            );
        }
    };

    const handleLogout = async () => {
        await signOut(auth);
        if ((window as any).isFlutterWebView) {
            // Send message to Flutter to navigate to native login
            sendFlutterMessage("navigateToLogin");
        } else {
            // normal web navigation
            navigate("/login", { replace: true });
        }
        console.log("User logged out");
    };

    if (signedIn) {
        return (
            <Button
                fullWidth={props.fullWidth}
                onClick={handleLogout}
                variant="contained"
                sx={props.sx ? props.sx : { margin: "0 8px", background: "#162C1F", border: "1px solid #162C1F", borderRadius: "24px" }}

            >
                <Typography variant="button" component="h1" sx={{ color: "ECE8D5" }}>
                    <AsyncString stringId="sign-out" />
                </Typography>
            </Button>
        );
    } else {
        return (
            <Button
                fullWidth={props.fullWidth}
                href="/login"
                onClick={handleLogout}
                variant="outlined"
                sx={props.sx ? props.sx : { margin: "0 8px", border: "1px solid #162C1F", borderRadius: "24px" }}
            >
                <Typography variant="button" component="h1" sx={{ color: "#162C1F" }}>
                    <AsyncString stringId="sign-in" />
                </Typography>
            </Button>
        );
    }
}